import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

const projectSchema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required("Project name is required")
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name must be less than 50 characters"),
    description: yup
      .string()
      .max(500, "Description must be less than 500 characters")
      .nullable(),
  })
  .required();

const ProjectForm = ({ onSubmit, onCancel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, dirtyFields },
    watch,
  } = useForm({
    resolver: yupResolver(projectSchema),
    mode: "all",
    defaultValues: {
      name: "",
      description: "",
    },
  });

  const nameValue = watch("name");
  const isNameValid = nameValue?.trim().length >= 3;
  const isSubmitDisabled = !isNameValid;

  const handleOnSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <div className="flex flex-col gap-6">
      <form
        onSubmit={handleSubmit(handleOnSubmit)}
        className="flex flex-col gap-6"
      >
        <div className="flex flex-col gap-2.5">
          <Label htmlFor="name">
            Name<span className="text-orange-500">*</span> :
          </Label>
          <Input
            {...register("name")}
            type="text"
            id="name"
            placeholder="Project name"
            className={`col-span-2 ${
              errors.name ? "border-red-500 focus:border-red-500" : ""
            }`}
            aria-invalid={errors.name ? "true" : "false"}
          />
          {errors.name && (
            <span className="text-sm text-red-500" role="alert">
              {errors.name.message}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-2.5">
          <Label htmlFor="description">Description:</Label>
          <Textarea
            {...register("description")}
            id="description"
            placeholder="Project description"
            className={`col-span-2 ${
              errors.description ? "border-red-500 focus:border-red-500" : ""
            }`}
            aria-invalid={errors.description ? "true" : "false"}
          />
          {errors.description && (
            <span className="text-sm text-red-500" role="alert">
              {errors.description.message}
            </span>
          )}
        </div>

        <div className="flex justify-between w-full items-center mt-4">
          <Button
            type="button"
            variant="secondary"
            size="compact"
            className="text-md font-semibold"
            onClick={onCancel}
          >
            <span>Cancel</span>
          </Button>
          <Button
            type="submit"
            variant="primary"
            size="compact"
            className="text-md font-semibold ml-3"
            disabled={isSubmitDisabled}
          >
            <span>Create API Key</span>
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ProjectForm;
